import { render } from "./CreateFAQComponent.vue?vue&type=template&id=9cddd652"
import script from "./CreateFAQComponent.vue?vue&type=script&lang=js"
export * from "./CreateFAQComponent.vue?vue&type=script&lang=js"

import "./CreateFAQComponent.vue?vue&type=style&index=0&id=9cddd652&lang=scss"

import exportComponent from "/var/www/nexgen/apps/admin/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__